import { render, staticRenderFns } from "./InfoInput.vue?vue&type=template&id=127579bc&scoped=true&"
import script from "./InfoInput.vue?vue&type=script&lang=ts&"
export * from "./InfoInput.vue?vue&type=script&lang=ts&"
import style0 from "./InfoInput.vue?vue&type=style&index=0&id=127579bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127579bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('127579bc')) {
      api.createRecord('127579bc', component.options)
    } else {
      api.reload('127579bc', component.options)
    }
    module.hot.accept("./InfoInput.vue?vue&type=template&id=127579bc&scoped=true&", function () {
      api.rerender('127579bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InfoInput.vue"
export default component.exports